export const MODULE_ID = 'app';
export const META_COMPONENT_NAME = 'AID';
export const SIGNALR_MODULE_ID = 'app-signalR';
export const SIGNALR_HUB_NAME = 'publicHub';
export const SIGNALR_NOTIFICATION_RECEIVE_MSG = 'EventReceived';
export const DEFAULT_LOCALE = 'en';
export const DEFAULT_COUNTRY_CODE = 'en';
// If you're adding locale see webpack.config.js MomentLocalesPlugin
export const APP_LOCALES = [
    'en-gb',
    'en',
    'en-au',
    'en-ie',
    'en-hk',
    'en-sg',
    'ar',
    'bg',
    'cs',
    'da',
    'de',
    'de-ch',
    'el',
    'es',
    'et',
    'fi',
    'fr',
    'fr-ca',
    'fr-ch',
    'he',
    'hr',
    'hy-am',
    'id',
    'is',
    'it',
    'it-ch',
    'lt',
    'lv',
    'nl',
    'nn',
    'pl',
    'pt',
    'pt-br',
    'ro',
    'ru',
    'sk',
    'sl',
    'sr',
    'sv',
    'th',
    'tr',
    'uk',
    'zh-cn',
    'zh-hk'
];
// limited list of APP_LOCALES for alpine
export const MOBILE_APP_LOCALES = [
    'en',
    'bg',
    'cs',
    'da',
    'de',
    'el',
    'es',
    'et',
    'fi',
    'fr',
    'hr',
    'is',
    'it',
    'lt',
    'lv',
    'nl',
    'nn',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sl',
    'sr',
    'sv',
    'tr',
    'uk',
    'zh-cn',
    'zh-hk'
];
export const APP_LOCALE_LANGUAGES_MAP = {
    'hy-am': 'hy',
    nn: 'no',
    'zh-cn': 'zh-Hans',
    'zh-hk': 'zh-Hant'
};
export const TRANSLATIONS_LOCATIONS = [
    'components/Form',
    'modules/App',
    'modules/Account',
    'modules/Administration',
    'modules/Information',
    'modules/Integration',
    'modules/Layout',
    'modules/Mobile',
    'modules/Organization',
    'modules/OrganizationAdmin',
    'modules/Preferences',
    'modules/Profile'
];
export const CONTACT_EMAIL = 'support@glucocontro.online';
export const SUPPORT_URL = 'https://support.glucocontro.online/hc/';
export const MOBILE_SUPPORT_URL = 'https://support.glucocontro.online/hc/en-us/categories/8909045125148-CONTOUR-Diabetes-App-Guides';
export const AVATAR_CROP_MODAL = `${MODULE_ID}/avatarCropModal`;
export const FEATURE_TOGGLES = {
    featureCgm: 'featureCgm'
};
export const LANGUAGE_SELECTOR_DROPDOWN = `${MODULE_ID}/languageSelectorDropdown`;
export const UNSAVED_CHANGES_MODAL = `${MODULE_ID}/unsavedChangesModal`;
export const DOB_FORMAT_COOKIE = 'dob-format';
export const DATE_FORMAT_COOKIE = 'date-format';
export const STATIC_FILES_SETTINGS = {
    POLICY: {
        DIR: 'pp',
        FILENAME_PATTERN: 'PrivacyPolicy-Cookies-for-AlpineCDA-GCO'
    },
    EULA: {
        DIR: 'eula',
        FILENAME_PATTERN: 'EULA-for-AlpineCDA-GCO'
    }
};
